import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Errored from '../../core/Errored';
import EventBar from '../../core/EventBar';
import EventProvider from '../../core/providers/EventProvider';
import ProjectProvider from '../../core/providers/ProjectProvider';
import { processHashLocation } from '../../core/utils/utils';
import GS from '../../grafsync/grafsync';
import CollectionData from './CollectionData';
import CollectionEditorContainer from './CollectionEditorContainer';

class CollectionsManager extends Component {

  constructor(props) {
    super(props);
    const initState = CollectionsManager.computeState(props);
    this.state = Object.assign(
      {
        viewValue: 1
      }, initState);
  }

  static getDerivedStateFromProps(props) {
    return CollectionsManager.computeState(props);
  }

  static computeState(props) {
    const paramsMap = processHashLocation(props.location);
    const collectionIRI = paramsMap.get("collection");
    let isErrored = !collectionIRI || collectionIRI === "";
    try {
      const projectData = GS.data(props.id, props.graph);
      if (!projectData.hasComponent.includes(collectionIRI)) isErrored = true;
    }
    catch (e) {

      isErrored = true;
    }
    return {
      collectionIRI,
      isErrored
    };
  }

  toggleCollectionDetail = (value) => this.setState({ viewValue: value });

  render() {

    const { viewValue, collectionIRI, isErrored } = this.state;
    const { graph, entitlements, data, projectUsers } = this.props;

    if (isErrored) return <Errored data={{ message: "This collection may have just been deleted or an invalid collection IRI has been provided in the URL." }} />;

    return (
      <ProjectProvider value={this.props.data}>
        <EventProvider>
          <EventBar defaultLang={data.defaultLang} />
        </EventProvider>
        {
          viewValue === 0 ?
            <CollectionData
              key={collectionIRI}
              id={collectionIRI}
              graph={graph}
              entitlements={entitlements}
              projectIRI={this.props.id}
              collectionIRI={collectionIRI}
              toggleCollectionDetail={this.toggleCollectionDetail} />
            :
            <CollectionEditorContainer
              id={collectionIRI}
              entitlements={entitlements}
              key={collectionIRI}
              graph={graph}
              projectUsers={projectUsers}
              skosXL={this.props.data.skosXL || false}
              project={this.props.id}
              defaultLang={this.props.data.defaultLang}
              toggleCollectionDetail={this.toggleCollectionDetail} />
        }
      </ProjectProvider>
    );
  }
}

CollectionsManager.propTypes = {
  data: PropTypes.object.isRequired,
  entitlements: PropTypes.array.isRequired,
  graph: PropTypes.string.isRequired,
  projectUsers: PropTypes.array,
  id: PropTypes.string.isRequired,
  project: PropTypes.string.isRequired
};

export default withRouter(CollectionsManager);
